import styled from '@emotion/styled';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import useClickOutside from '../../../shared/designSystem/hooks/useClickOutside';
import usePreventBodyScroll from '../../../shared/designSystem/hooks/usePreventBodyScroll';
import { globalVariables } from '../../../shared/designSystem/constants';

import LoggedInItems from './LoggedInItems';
import LoggedOutItems from './LoggedOutItems';

type Props = {
  isOpen: boolean;
  direction?: 'left' | 'right';
  onClose: () => void;
};

export default function SideBar({ isOpen, direction = 'left', onClose }: Props) {
  const { user } = useLayoutHeaderContext();
  const { ref } = useClickOutside(isOpen, [], onClose);
  usePreventBodyScroll(isOpen);

  const isLoggedIn = user && user.id;

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Container ref={ref} direction={direction}>
        {isLoggedIn ? <LoggedInItems /> : <LoggedOutItems />}
      </Container>
      <Dimmed />
    </>
  );
}

const Container = styled.aside<{ direction: 'left' | 'right' }>`
  position: fixed;
  top: 0;
  ${({ direction }) => (direction === 'left' ? 'left: 0;' : 'right: 0;')}
  width: 240px;
  height: 100%;
  overflow-y: auto;
  background-color: ${globalVariables.white};
  z-index: ${globalVariables.z_dialog};
`;

const Dimmed = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: ${globalVariables.black};
  opacity: 0.3;
  z-index: ${globalVariables.z_dialog - 1};
`;
